import createActionType from "../../utils/createActionType";

export const MODULE = "planner/orders";

export const SET_IS_FETCHING_ORDERS = createActionType(MODULE, "setIsFetchingOrders");

export const SET_IS_REPLACING_ORDERS = createActionType(MODULE, "setIsReplacingOrders");

export const SET_ORDERS = createActionType(MODULE, "setOrders");

export const SET_OFFSET = createActionType(MODULE, "setOffset");

export const SET_TOTAL = createActionType(MODULE, "setTotal");

export const SET_HAS_NEXT_PAGE = createActionType(MODULE, "setHasNextPage");

export const SET_HAS_FETCHED = createActionType(MODULE, "setHasFetched");

export const SET_SCHEDULE_STATE_COUNTS = createActionType(MODULE, "setScheduleStateCounts");

export const RESET = createActionType(MODULE, "reset");
